import { useState } from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { useLang } from "../i18n";

const RacketIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="10" cy="9.5" r="6.5" />
    <path d="M14.6 14.6 L19.5 20.5" />
    <circle cx="20" cy="6.5" r="1.6" />
  </svg>
);

const getIcon = (name) => (name === "Racket" ? RacketIcon : Icons[name] || Icons.Dot);

export const Amenities = () => {
  const { t } = useLang();
  const [showAll, setShowAll] = useState(false);
  const items = showAll ? t.amenities.items : t.amenities.items.slice(0, 10);
  return (
    <section id="equipements" className="bg-ink text-sand-bg py-24 md:py-36" data-testid="amenities-section">
      <div className="px-6 md:px-12 max-w-[1600px] mx-auto">
        <div className="max-w-2xl mb-16 md:mb-24">
          <span className="text-[11px] tracking-[0.35em] uppercase text-terracotta">{t.amenities.eyebrow}</span>
          <h2 className="font-serif font-light text-4xl md:text-6xl mt-4 tracking-tight text-sand-bg">
            {t.amenities.title}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-y-12 gap-x-8">
          {items.map((a, i) => {
            const iconNames = a.icons || [a.icon];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: (i % 5) * 0.08, ease: [0.19, 1, 0.22, 1] }}
                className="border-t border-white/15 pt-5 group"
                data-testid={`amenity-${i}`}
              >
                <div className="flex items-center gap-3 mb-4">
                  {iconNames.map((n) => {
                    const Icon = getIcon(n);
                    return <Icon key={n} className="w-6 h-6 text-terracotta transition-transform duration-500 group-hover:-translate-y-1" strokeWidth={1.3} />;
                  })}
                </div>
                <p className="font-light text-sand-bg/90 text-sm md:text-base">{a.label}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-14 text-center">
          <button
            onClick={() => setShowAll((v) => !v)}
            data-testid="amenities-toggle"
            className="inline-flex items-center gap-2 text-sm tracking-wide text-terracotta link-underline hover:text-sand-bg transition-colors"
          >
            {showAll ? t.amenities.less : t.amenities.more}
          </button>
        </div>
      </div>
    </section>
  );
};
